import { BaseRepository } from "@/repository/base";
import { ITipGroup } from "@/schemas/ITipGroup";

const tipGroupRepository = new BaseRepository<ITipGroup>("tip_groups");

export default tipGroupRepository;
